import React from 'react';

import ToolsBox from 'src/components/ToolsBox';
import toolsPropTypes from 'src/types/toolsPropTypes';
import 'src/containers/ToolsBoxWrapper.scss';


const ToolsBoxWrapper = ({ tools }) => (
  <>
    <div styleName="tools-box-wrapper">
      {
        tools.map(({
          title, link, icon, subtitle, testName
        }) => (
          <ToolsBox
            key={ title }
            icon={ icon }
            link={ link }
            subtitle={ subtitle }
            testName={ testName }
            title={ title }
          />
        ))
      }
    </div>
  </>
);

ToolsBoxWrapper.propTypes = toolsPropTypes;

export default ToolsBoxWrapper;
